import { render } from "./TabelaClassificacao.vue?vue&type=template&id=2f13183c&scoped=true"
import script from "./TabelaClassificacao.vue?vue&type=script&lang=js"
export * from "./TabelaClassificacao.vue?vue&type=script&lang=js"

import "./TabelaClassificacao.vue?vue&type=style&index=0&id=2f13183c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f13183c"]])

export default __exports__